'use client'

import React from 'react'
import whyDidYouRender from '@welldone-software/why-did-you-render'

if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_WDYR_MODE === 'on') {
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  })
}